import { render, staticRenderFns } from "./AbilityTab.vue?vue&type=template&id=295157f6&scoped=true"
import script from "./AbilityTab.vue?vue&type=script&lang=js"
export * from "./AbilityTab.vue?vue&type=script&lang=js"
import style0 from "./AbilityTab.vue?vue&type=style&index=0&id=295157f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295157f6",
  null
  
)

export default component.exports